<template>
  <div class="home">
    <!-- 轮播图 -->
    <section class="banner-section">
      <el-carousel height="500px" :interval="5000" arrow="always">
        <el-carousel-item v-for="(item, index) in banners" :key="index">
          <div class="banner-slide" :style="{ backgroundImage: `url(${item.image})` }">
            <div class="container">
              <div class="banner-content">
                <h2>{{ item.title }}</h2>
<!--                <el-button type="primary" size="medium" @click="goToPage(item.link)">-->
<!--                  {{ item.buttonText }}-->
<!--                </el-button>-->
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

      <!-- 动态区块 -->
    <section class="news-section section"style="background-color: #fff;">
      <div class="container">
        <div class="section-title" style="text-align: center; margin-bottom: 0;">
          <h2>动态资讯</h2>
          <div style="display: flex; justify-content: center;">
          <el-tabs v-model="activeNewsTab" @tab-click="handleTabClick" class="news-tabs" style="display: inline-block; ">
            <el-tab-pane label="企业动态" name="company"></el-tab-pane>
            <el-tab-pane label="行业资讯" name="industry"></el-tab-pane>
          </el-tabs>
          </div>
        </div>
        <el-row :gutter="40">
          <el-col :xs="24" :sm="12" v-for="(item, idx) in currentNewsList" :key="idx" style="margin-bottom: 30px;">
            <div class="news-item" @click="showProductDetail(item)" style="cursor: pointer;">
              <div class="news-date">{{ item.date }}</div>
              <div class="news-content">
                <div class="news-img">
                  <img :src="item.image" :alt="item.name" />
                </div>
                <div class="news-info">
                  <div class="news-title" v-html="item.name"></div>
                  <div class="news-desc">{{ getPlainText(item.shortDescription) }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="news-pagination">

          <!-- <el-button type="primary" size="medium" @click="goToPage(solution.link)">
            查看详情
          </el-button> -->
          <div style="display: flex; font-size: 16px;  color: #1ebec8;  align-items: center; cursor: pointer;" @click="navigateWithDynamic(activeNewsTab)">
              更多 <i style="font-size: 18px; margin-left: 4px; margin-top: 3px; color: #1ebec8; " class="el-icon-d-arrow-right"></i>
          </div>
          
          <!-- <el-pagination
            background
            layout="prev, pager, next"
            :total="newsTotal"
            :page-size="4"
            :background-color='"#fff"'
            :current-page.sync="newsPage"
            small
            :background="true"
            style="background-color: #fff;"
            @current-change="handleNewsPageChange"
          /> -->
        </div>
      </div>
    </section>

    <!-- 产品类别 -->
    <!-- <section class="products-section section">
      <div class="container">
        <div class="section-title">
          <h2>产品中心</h2>
          <p>为工程造价管理提供全面的软件和解决方案</p>
        </div>
        
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8" v-for="(product, index) in productCategories" :key="index">
            <div class="product-card" @click="goToPage(product.link)">
              <div class="product-img">
                <img :src="product.image" :alt="product.title">
              </div>
              <div class="product-content">
                <h3>{{ product.title }}</h3>
                <p>{{ product.description }}</p>
                <span class="more-link">了解更多 <i class="el-icon-arrow-right"></i></span>
              </div>
            </div>
          </el-col>
        </el-row>

      </div>
    </section> -->

    <!-- 解决方案 -->
    <section class="solutions-section section" style="background-color: #f5f5f5;">
      <div class="container">
        <div class="section-title" style="margin-bottom: 0;">
          <h2 >核心业务</h2>
          <!-- <p>针对市场需求制定的核心业务</p> -->
        </div>
        
        <el-tabs id="core-business" v-model="activeSolution" class="solution-tabs">
          <el-tab-pane v-for="(solution, index) in solutions" :key="index" :label="solution.title" :name="solution.name">
            <div class="solution-content">
              <div class="solution-image">
                <img :src="solution.image" :alt="solution.title">
              </div>
              <div class="solution-info">
                <h3>{{ solution.title }}</h3>
                <p>{{ solution.description }}</p>
                <ul class="solution-features">
                  <li v-for="(feature, fIndex) in solution.features" :key="fIndex">
                    <i class="el-icon-check"></i> {{ feature }}
                  </li>
                </ul>
                <!-- <el-button type="primary" size="medium" @click="goToPage(solution.link)">
                  查看详情
                </el-button> -->
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>


    <!-- 行业案例 -->
    <section class="industry-section section">
      <div class="container">
        <div class="section-title" style="text-align: center; margin-bottom: 0;">
          <h2 id="industry-cases">行业案例</h2>
          <div style="display: flex; justify-content: center;">
            <el-tabs v-model="activeIndustryTab" class="industry-tabs" style=" max-width: 500px;">
              <el-tab-pane label="信息化项目造价咨询" name="xxhxmzjzx"></el-tab-pane>
              <el-tab-pane label="工程项目造价咨询" name="gzxmzjzx"></el-tab-pane>
              <el-tab-pane label="可行性研究报告" name="kxxyjbg"></el-tab-pane>
            </el-tabs>
          </div>
          <!-- <div v-if="activeIndustryTab" style="color: #666; font-size: 14px; margin-bottom: 20px;">
            {{ industryTabDesc[activeIndustryTab] }}
          </div> -->
        </div>
        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="6" v-for="(item, idx) in currentIndustryCases" :key="idx" style="margin-bottom: 30px;">
            <el-tooltip placement="top" :open-delay="300"  :content="item.name">
              <div class="industry-card" @click="showIndustryDetail(item)" style="cursor: pointer;">
                <div class="industry-img"> 
                  <img  slot="reference" :src="item.image" :alt="item.name" />
                </div>
                <div class="industry-info">  
                  <div class="industry-type">{{ item.name }}</div>
                  <!-- <span class="industry-arrow"><i class="el-icon-arrow-right"></i></span> -->
                </div>
              </div>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="news-pagination">

          <!-- <el-button type="primary" size="medium" @click="goToPage(solution.link)">
            查看详情
          </el-button> -->
          <div style="display: flex; font-size: 16px; color: #1ebec8;  cursor: pointer; align-items: center;" @click="navigateWithIndustry(activeIndustryTab)">
              更多 <i style="font-size: 18px; margin-left: 4px; margin-top: 3px; color: #1ebec8; " class="el-icon-d-arrow-right"></i>
          </div>
          
          <!-- <el-pagination
            background
            layout="prev, pager, next"
            :total="newsTotal"
            :page-size="4"
            :background-color='"#fff"'
            :current-page.sync="newsPage"
            small
            :background="true"
            style="background-color: #fff;"
            @current-change="handleNewsPageChange"
          /> -->
        </div>
      </div>
    </section>

  

    <!-- 关于我们 -->
    <section class="about-section section" style="background-color: #f5f5f5;">
      <div class="container">
        <div class="about-content">
          <div class="about-info">
            <h2>关于正略智研</h2>
            <p>河南正略智研工程咨询有限公司是一家专注于信息化项目造价咨询的企业，公司拥有专业、强大的技术团队，包括软件工程造价师、信息系统审计师、信息系统监理师、注册造价工程师、咨询工程师（投资类）、软件开发工程师等，并拥有多名高级工程师、中级工程师，为政府部门、国有企业、事业单位、中国人民解放军、上市公司等众多客户长期提供专业的咨询服务。</p>
            <div class="about-statistics">
              <div class="stat-item">
                <div class="stat-number">18</div>
                <div class="stat-title">年行业经验</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">100+</div>
                <div class="stat-title">专业人才</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">500+</div>
                <div class="stat-title">成功案例</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">20+</div>
                <div class="stat-title">专利技术</div>
              </div>
            </div>
            <el-button type="primary" @click="goToPage('/about')">了解更多</el-button>
          </div>
          <div class="about-image">
            <img src="/img/004.jpg" alt="关于格瑞泰克" style="width: 100%; height: 300px; object-fit: cover; border-radius: 4px;">
          </div>
        </div>
      </div>
    </section>
<!-- 
    合作伙伴
    <section class="partners-section section" style="background-color: #f5f5f5;">
      <div class="container">
        <div class="section-title">
          <h2>合作伙伴</h2>
          <p>共同创造价值，共享发展成果</p>
        </div>
        
        <div class="partners-carousel-container">
          <el-carousel :interval="3000" type="card" height="280px">
            <el-carousel-item v-for="(partner, index) in partners" :key="index">
              <div class="partner-item">
                <img :src="partner.logo" :alt="partner.name">
                <div class="partner-overlay">
                  <h3>{{ partner.name }}</h3>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section> -->

    <!-- 工程管理科技生态圈 -->
    <!-- <section class="ecosystem-section section" style="background-color: #364150;">
      <div class="container">
        <div class="section-title ecosystem-title">
          <h2>项目案例</h2>
        </div>
        
        <el-row :gutter="30"> -->
          <!-- 第一行卡片 -->
          <!-- <el-col :xs="24" :sm="12" :md="6" v-for="(item, index) in ecosystemItems.slice(0, 4)" :key="index">
            <div class="ecosystem-card" @click="goToPage(item.link)">
              <div class="ecosystem-card-content" :style="{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${item.image})` }">
                <h3>{{ item.title }}</h3>
              </div>
              <div class="ecosystem-card-footer">
                <span class="ecosystem-card-tag">{{ item.tag }}</span>
                <el-button type="text" class="ecosystem-detail-btn" v-if="item.hasDetailBtn">查看详情</el-button>
              </div>
            </div>
          </el-col> -->
          
          <!-- 第二行卡片 -->
          <!-- <el-col :xs="24" :sm="12" :md="6" v-for="(item, index) in ecosystemItems.slice(4, 8)" :key="index + 4">
            <div class="ecosystem-card" @click="goToPage(item.link)">
              <div class="ecosystem-card-content" :style="{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${item.image})` }">
                <h3>{{ item.title }}</h3>
              </div>
              <div class="ecosystem-card-footer">
                <span class="ecosystem-card-tag">{{ item.tag }}</span>
                <el-button type="text" class="ecosystem-detail-btn" v-if="item.hasDetailBtn">查看详情</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section> -->

    <!-- 联系我们 -->
    <section class="contact-section section" style="background-color: #fff;">
      <div class="container">
        <div class="contact-content">
          <div class="contact-info">
            <h2>联系我们</h2>
            <p>如果您对我们的产品和服务有任何疑问，请随时联系我们。</p>
            <div class="contact-methods">
              <div class="contact-method">
                <img src="/img/bluePhone.svg">
                <div class="method-details">
                  <h3>电话咨询</h3>
                  <p>13525947399</p>
                </div>
              </div>
              <div class="contact-method">
                <img src="/img/blueEmail.svg">
                <div class="method-details">
                  <h3>邮件咨询</h3>
                  <p>hnzlzygczx@163.com</p>
                </div>
              </div>
              <div class="contact-method">
                <img src="/img/address.svg">
                <div class="method-details">
                  <h3>公司地址</h3>
                  <p>河南省洛阳市西工区数码大厦</p>
                  <p>河南省郑州市金水区瀚海爱特中心</p>
                </div>
              </div>
            </div>
          </div>
          <div class="contact-image">
            <img src="/img/007.jpeg" alt="公司图片" class="company-image">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {productQY} from '@/views/DynamicQy.js';
import {productHY} from '@/views/DynamicHy.js';
import {productKx} from '@/views/industData/IndustryKx.js';
import {productZj} from '@/views/industData/IndustryZj.js';
import {productXx} from '@/views/industData/IndustryXx.js';
export default {
  name: 'Home',
  data() {
    return {
      activeSolution: 'industrial',
      banners: [
        {
          title: '信息化项目造价咨询累计评审金额10亿+',
          subtitle: '',
          buttonText: '查看产品',
          link: '/products',
          image: '/img/xxhxmzj.jpg' // 修改为007-013之间循环
        },
        {
          title: '工程造价全过程管理解决方案',
          subtitle: '为您的项目提供全面的造价咨询服务和系统',
          buttonText: '了解更多',
          link: '/solutions',
          image: '/img/banner2.jpg' // 修改为007-013之间循环
        },
        {
          title: '7x24小时专业技术支持',
          subtitle: '全方位的服务保障，技术支持',
          buttonText: '联系我们',
          link: '/contact',
          image: '/img/banner01.jpg' // 修改为007-013之间循环
        }
      ],
      productCategories: [
        {
          title: '造价软件系统',
          description: '高性能造价预算软件，满足各种工程项目的造价管理需求',
          link: '/products',
          image: '/img/035.png' // 修改为007-013之间循环
        },
        {
          title: '数据分析平台',
          description: 'BIM、大数据分析、云计算系统，提供完整的工程造价数据分析方案',
          link: '/products',
          image: '/img/036.png' // 修改为007-013之间循环
        },
        {
          title: '招投标管理',
          description: '电子招投标系统和解决方案，打造高效透明的招投标管理网络',
          link: '/products',
          image: '/img/037.jpg' // 保留不变
        }
      ],
      solutions: [
        {
          name: 'industrial',
          title: '信息化项目造价咨询',
          description: '针对各类软件项目造价咨询、信息化项目造价咨询提供全面解决方案。',
          features: [
            '信息化项目预算编制',
            '信息化项目结算审计',
            '信息化项目控制价评审',
            '软件项目预算编制',
            '软件项目结算审计',
            '软件项目控制价评审'
          ],
          link: '/solutions',
          image: '/img/hxyw_xxhzj.jpg' // 修改为007-013之间循环
        },
        {
          name: 'xxxtsjzx',
          title: '信息系统审计咨询',
          description: '针对信息化项目、运维项目提供安全性、可靠性、经济性审计服务解决方案。',
          features: [
            '信息系统管理控制审计',
            '信息系统安全控制审计',
            '信息系统应用控制审计',
            '信息系统网络控制审计',
            '信息系统数据控制审计'
          ],
          link: '/solutions',
          image: '/kxx/k003.png' // 修改为007-013之间循环
        },
         {
          name: 'building',
          title: '工程项目造价咨询',
          description: '针对各类工程项目提供全过程造价咨询解决方案。',
          features: [
            '工程项目预算编制',
            '工程项目结算审计',
            '工程项目控制价评审'
          ],
          link: '/solutions',
          image: '/img/008.jpg' // 修改为007-013之间循环
        },
        {
          name: 'energy',
          title: '信息系统监理',
          description: '针对信息化项目全过程提供监理解决方案。',
          features: [
            '信息化项目过程监理',
            '信息化项目运维监理',
            '信息化项目验收监理'  
          ],
          link: '/solutions',
          image: '/img/hxyw_xxxtjl.jpg' // 修改为007-013之间循环
        },
        {
          name: 'gczxfw',
          title: '工程咨询服务',
          description: '为各类公共基础设施项目提供专业、全面的可行性研究服务，涵盖项目背景、技术路线、投资估算与经济效益分析等关键内容。',
          features:  [
            "绩效评价报告",
            "可行性研究报告",
            "投资后评价报告",
            "投资效益分析报告"
          ],
          link: '/solutions',
          image: '/img/009.jpeg' // 修改为007-013之间循环
        },
         {
          name: 'rjkf',
          title: '软件开发',
          description: '为政府、企事业单位、咨询机构提供专业产品和高效的软件技术服务。',
          features: [
            "造价星·咨询项目管理平台",
            "数智档案管理系统",
            "报名签到平台",
            "软件定制开发",
            "解决方案咨询"
          ],
          link: '/solutions',
          image: '/img/015.jpg' // 修改为007-013之间循环
        }
      ],
      partners: [
        { name: '合作伙伴1', logo: '/img/042.png' }, // 修改为007-013之间循环
        { name: '合作伙伴2', logo: '/img/043.png' }, // 修改为007-013之间循环
        { name: '合作伙伴3', logo: '/img/044.png' }, // 保留不变
        { name: '合作伙伴4', logo: '/img/045.png' }, // 修改为007-013之间循环
        { name: '合作伙伴5', logo: '/img/046.png' }, // 修改为007-013之间循环
      ],
      contactForm: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      // 工程管理科技生态圈数据
      ecosystemItems: [
        {
          title: '某县智慧停车场建设项目系统平台搭建设备采购造价咨询服务（信息化类）',
          tag: 'AIOT物联感知',
          image: '/img/038.png', // 修改为007-013之间循环
          link: '/ecosystem/bim-tech'
        },
        {
          title: '某景区智能化票务系统更新升级项目造价咨询服务（信息化类）',
          tag: '云服务系统',
          image: '/img/039.png', // 修改为007-013之间循环
          link: '/ecosystem/bim-consulting',
          hasDetailBtn: true
        },
        {
          title: '信息化档案管理系统造价咨询服务（信息化类）',
          tag: '建设档案大数据',
          image: '/img/040.png', // 保留不变
          link: '/ecosystem/construction-data'
        },
        {
          title: '某市医保管理系统造价咨询服务（信息化类）',
          tag: '支持AI大模型',
          image: '/img/041.png', // 修改为007-013之间循环
          link: '/ecosystem/cost-consulting'
        },
        {
          title: '某县智慧停车场建设项目系统平台搭建设备采购造价咨询服务（信息化类）',
          tag: 'AIOT物联感知',
          image: '/img/038.png', // 修改为007-013之间循环
          link: '/ecosystem/bim-tech'
        },
        {
          title: '某景区智能化票务系统更新升级项目造价咨询服务（信息化类）',
          tag: '云服务系统',
          image: '/img/039.png', // 修改为007-013之间循环
          link: '/ecosystem/bim-consulting',
          hasDetailBtn: true
        },
        {
          title: '信息化档案管理系统造价咨询服务（信息化类）',
          tag: '建设档案大数据',
          image: '/img/040.png', // 保留不变
          link: '/ecosystem/construction-data'
        },
        {
          title: '某市医保管理系统造价咨询服务（信息化类）',
          tag: '支持AI大模型',
          image: '/img/041.png', // 修改为007-013之间循环
          link: '/ecosystem/cost-consulting'
        }
      ],
      industryCasesXxhxmzjzx: productZj,
      industryCasesGzxmzjzx: productXx,
      industryCasesKxxyjbg: productKx,
      activeIndustryTab: 'xxhxmzjzx',
      industryTabDesc: {
        xxhxmzjzx: '信息化项目累计评审金额超过10个亿',
        gzxmzjzx: '工程项目造价咨询',
        kxxyjbg: '可行性研究报告',
      },

      // 动态区块
       activeNewsTab: 'company',
      newsPage: 1,
      newsList: {
        company: productQY,
        industry: productHY
      
      },
    }
   
  },
// 假设这是你的 Vue 组件中的 mounted 钩子
  created() {
    // 保存 Vue 实例的 this
      let vm = this;
      const check = () => {
        const currentTab = new URL(location).searchParams.get('tab');
        const currenthyal = new URL(location).searchParams.get('hyal');
        const lastTab = check.lastTab;
        const lastHyal = check.lastHyal;
        if (currentTab !== lastTab ) {
          if(currentTab){
            vm.activeSolution = currentTab;
          }
          check.lastTab = currentTab;
        }
        if (currenthyal !== lastHyal ) {
          // 修改 Vue data 中的 activeSolution
          if(currenthyal){
            vm.activeIndustryTab = currenthyal;
          }
          check.lastHyal = currenthyal;
        }
    };
  
    this.checkInterval = setInterval(check, 400);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
      const url = new URL(window.location);
        window.history.pushState({}, '', url);
    }
  },
  computed: {
    currentIndustryCases() {
      if (this.activeIndustryTab === 'xxhxmzjzx') return this.industryCasesXxhxmzjzx.slice(0, 8);
      if (this.activeIndustryTab === 'gzxmzjzx') return this.industryCasesGzxmzjzx;
      if (this.activeIndustryTab === 'kxxyjbg') return this.industryCasesKxxyjbg;
      return [];
    },
    currentNewsList() {
      // 如果当前tab不是company或industry，默认company
      const validTabs = ['company', 'industry'];
      const tab = validTabs.includes(this.activeNewsTab) ? this.activeNewsTab : 'company';
      const list = this.newsList[tab] || [];
      const start = (this.newsPage - 1) * 4;
      return list.slice(start, start + 4);
    },
    newsTotal() {
      const validTabs = ['company', 'industry'];
      const tab = validTabs.includes(this.activeNewsTab) ? this.activeNewsTab : 'company';
      return (this.newsList[tab] || []).length;
    }
  },
  methods: {
    goToPage(path) {
      if (path) {
        this.$router.push(path);
      }
    },
    submitForm() {
      this.$message({
        message: '您的留言已提交，我们会尽快与您联系！',
        type: 'success'
      })
      this.contactForm = {
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    },
    showProductDetail(product) {
        // 获取当前路由的基础路径
      const baseUrl = window.location.origin;
      // 构造完整的跳转URL
      const url = `${baseUrl}/DynamicDetail?id=${product.id}`;
      // 在新窗口打开页面
      window.open(url, '_blank');
    },
    showIndustryDetail(product) {
      const baseUrl = window.location.origin;
      // 构造完整的跳转URL
      const url = `${baseUrl}/IndustryDetail?id=${product.id}`;
      // 在新窗口打开页面
      window.open(url, '_blank');
    },
    handleNewsPageChange(page) {
      this.newsPage = page;
    },
    handleTabClick(tab, event) {
      this.newsPage = 1; // 重置页码
      this.activeNewsTab = tab.name;
      
    },
    navigateWithDynamic(tab) {
      this.$router.push({
        path: '/Dynamic',
        query: { tab: tab }
      });
    },
    navigateWithIndustry(tab) {
      this.$router.push({
        path: '/Industry',
        query: { tab: tab }
      });
     },
    getPlainText (html) {
      const content = html || ''
      // 方法1：使用 DOMParser（推荐，更准确）
      const parser = new DOMParser()
      const doc = parser.parseFromString(content, 'text/html')
      // 先trim()去除首尾空格，然后替换所有剩余的空格
      return doc.body.textContent.trim().replace(/\s+/g, '')

      // 方法2：使用正则（简单场景可用）
      // return content.replace(/<[^>]+>/g, '').trim().replace(/\s+/g, '');
    },
  }
}
</script>

<style lang="scss" scoped>
.industry-tabs {
  padding-right: 0 !important;

  @media (max-width: 768px) {
    max-width: 100% !important;
    padding-right: 0 !important;
    margin-right: 0 !important;
  }
}
// 行业案例样式
.industry-section {
  background: #fff;
  .section-title {
    h2 {
      font-size: 32px;
      font-weight: 600;
      // margin-bottom: 10px;
    }
  
  }
  .industry-card {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);
    overflow: hidden;
    transition: box-shadow 0.3s, transform 0.3s;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    // height: 100%;
    height: 280px; /* 设置最小高度 */
   
    &:hover {
      box-shadow: 0 8px 24px 0 rgba(0,0,0,0.12);
      transform: translateY(-4px);
    }
    .industry-img {
      width: 100%;
      height: 200px;
      overflow: hidden;

      @media (max-width: 868px) {
        height:200px !important;
        padding: 0px; 
        margin-bottom: 10px ; 
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s;
      }
    }
    .industry-info {
      padding: 5px 16px 5px 16px;
      background: #fff;
      position: relative;
      flex-grow: 1; /* 使信息部分占据剩余空间 */
      .industry-type {
        font-size: 15px;
        line-height: 30px;
        color: #666;
        font-weight: 500;
        margin-bottom: 6px;
        display: -webkit-box; 
        -webkit-box-orient: vertical; 
        -webkit-line-clamp: 2; 
        overflow: hidden; 
      }
      .industry-arrow {
        position: absolute;
        right: 16px;
        bottom: 12px;
        color: #bbb;
        font-size: 18px;
      }
    }
  }
  .news-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
.banner-section {
  .banner-slide {
    height: 100%;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
  }
  
  .banner-content {
    max-width: 650px;
    color: #fff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    
    h2 {
      font-size: 36px;
      margin-bottom: 15px;
    }
    
    p {
      font-size: 18px;
      margin-bottom: 25px;
    }
  }
}

.products-section {
  .product-card {
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    }
    
    .product-img {
      height: 200px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s;
      }
    }
    
    &:hover .product-img img {
      transform: scale(1.05);
    }
    
    .product-content {
      padding: 20px;
      
      h3 {
        font-size: 18px;
        margin-bottom: 10px;
        color: #333;
      }
      
      p {
        color: #666;
        margin-bottom: 15px;
        height: 60px;
        overflow: hidden;
      }
      
      .more-link {
        color: #1ebec8;
        font-size: 14px;
        display: inline-block;
        
        i {
          margin-left: 5px;
          transition: all 0.3s;
        }
        
        &:hover i {
          margin-left: 8px;
        }
      }
    }
  }
}

.solution-tabs {
  .solution-content {
    display: flex;
    align-items: center;
    
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 0px 10px 0px 10px;
    }
    .solution-image {
      width: 45%;
      padding-right: 30px;
      
      @media (max-width: 768px) {
        width: 388px;
        height: 200px;
        padding: 0px 10px 0px 10px; 
        margin-bottom: 20px;
      }
      
      img {
        width: 100%;
        height:330px;
        border-radius: 4px;
        @media (max-width: 868px) {
          width: 388px;
          height:210px;
          margin-bottom: 20px ; 
        }
      }
     
    }
    
    .solution-info {
      width: 55%;
      
      @media (max-width: 768px) {
        width: 100%;
      }
      
      h3 {
        font-size: 24px;
        margin-bottom: 15px;
        color: #333;
      }
      
      p {
        color: #666;
        margin-bottom: 20px;
      }
      
      .solution-features {
        margin-bottom: 25px;
        
        li {
          margin-bottom: 10px;
          color: #666;
          
          i {
            color: #666;
            margin-right: 10px;
          }
        
        }
      }
    }
  }
}

.about-section {
  .about-content {
    display: flex;
    align-items: center;
    
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
    
    .about-info {
      width: 50%;
      padding-right: 30px;
      
      @media (max-width: 768px) {
        width: 100%;
        padding-right: 0;
        margin-top: 30px;
      }
      
      h2 {
        font-size: 28px;
        margin-bottom: 20px;
        color: #333;
      }
      
      p {
        color: #666;
        margin-bottom: 15px;
        line-height: 1.6;
      }
      
      .about-statistics {
        display: flex;
        flex-wrap: wrap;
        margin: 30px 0;
        
        .stat-item {
          width: 25%;
          text-align: center;
          padding: 15px 10px;
          
          @media (max-width: 576px) {
            width: 50%;
            margin-bottom: 20px;
          }
          
          .stat-number {
            font-size: 30px;
            font-weight: bold;
            color: #1ebec8;
            margin-bottom: 5px;
          }
          
          .stat-title {
            color: #666;
            font-size: 14px;
          }
        }
      }
    }
    
    .about-image {
      width: 50%;
      
      @media (max-width: 768px) {
        width: 100%;
      }
      img {
        width: 100%;
        border-radius: 4px;
      @media (max-width: 768px) {
        height: 240px !important;
      }
      }
    }
  }
}

.partners-section {
  .section-title {
    h2 {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 15px;
    }
    
    p {
      font-size: 18px;
      color: #666;
      margin-bottom: 30px;
    }
  }

  .partners-carousel-container {
    padding: 20px 0;
    margin: 0 -30px;
  }
  
  .el-carousel__item {
    transform: scale(0.85);
    transition: transform 0.4s ease;
    
    &.is-active {
      transform: scale(1);
    }
  }
  
  .partner-item {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    padding: 0;
    overflow: hidden;
    position: relative;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s;
    }
    
    .partner-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 15px;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
      transition: all 0.3s;
      
      h3 {
        color: #fff;
        margin: 0;
        font-size: 18px;
        text-align: center;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }
    }
    
    &:hover {
      img {
        transform: scale(1.05);
      }
      
      .partner-overlay {
        background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.2));
      }
    }
  }
}
// 动态区块样式
.news-section {
  background: #f5f5f5;
  .section-title {
    h2 {
      font-size: 32px;
      font-weight: 600;
      // margin-bottom: 10px;
    }
    p {
      font-size: 18px;
      color: #666;
      // margin-bottom: 10px;
    }
    .news-tabs {
      margin-top: 10px;
      margin-bottom: 0  !important;
    }
  }
  .news-item {
    
    border-radius: 6px;
    padding: 18px 20px 18px 15px;
    margin-bottom: 10px;
    
    display: flex;
    flex-direction: column;
    @media (max-width: 868px) {
      padding: 5px 10px 5px 10px;
      margin-bottom: 0 !important;
    }
    &:hover {
      box-shadow: 0 8px 24px 0 rgba(0,0,0,0.12);
      transform: translateY(-4px);
    }
    .news-date {
      color: #bdbdbd;
      font-size: 20px;
      font-weight: 400;
      margin-bottom: 10px;
    }
    .news-content {
      display: flex;
      align-items: flex-start;   
      .news-img {
        width: 160px;
        height: 100px;
        border-radius: 4px;
        overflow: hidden;
        margin-right: 18px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .news-info {
        flex: 1;
        .news-title {
          font-size: 16px;
          font-weight: 600;
          color: #222;
          margin-bottom: 8px;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          @media (max-width: 868px) {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .news-desc {
          color: #888;
          font-size: 14px;
          line-height: 1.6;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .news-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}

/* 工程管理科技生态圈样式 */
.ecosystem-section {
  color: #fff;
  
  .ecosystem-title {
    h2 {
      color: #fff;
      
      &:after {
        background-color: #fff;
      }
    }
  }
  
  .ecosystem-card {
    margin-bottom: 30px;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    transition: all 0.3s;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }
    
    .ecosystem-card-content {
      height: 220px;
      padding: 20px;
      background-size: cover;
      background-position: center;
      position: relative;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      
      h3 {
        color: #fff;
        text-align: center;
        font-size: 16px;
        line-height: 1.5;
        margin: 0;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      }
    }
    
    .ecosystem-card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
      background-color: #fff;
      
      .ecosystem-card-tag {
        color: #1ebec8;
        font-size: 14px;
        font-weight: bold;
      }
      
      .ecosystem-detail-btn {
        color: #e60012;
        padding: 0;
      }
    }
  }
}

.contact-section {
  .contact-content {
    display: flex;
    
   @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
    
    .contact-info {
      width: 50%;
      padding-right: 30px;
      
      @media (max-width: 768px) {
        width: 100%;
        padding-right: 0;
        margin-top: 30px; 
      }
      
      h2 {
        font-size: 28px;
        margin-bottom: 15px;
        color: #333;
      }
      
      p {
        color: #666;
        margin-bottom: 30px;
      }
      
      .contact-methods {
        .contact-method {
          display: flex;
          align-items: flex-start;
          margin-bottom: 20px;
          
          img {
            width: 24px;
            height: 24px;
            margin-right: 15px;
            margin-top: 5px;
          }
          
          .method-details {
            h3 {
              font-size: 18px;
              margin-bottom: 5px;
              color: #333;
            }
            
            p {
              color: #666;
              margin-bottom: 0;
            }
          }
        }
      }
    }
    
    .contact-image {
      width: 50%;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      
      @media (max-width: 768px) {
        width: 100%;
      }
      
      .company-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
}
:deep(.news-pagination .el-pagination.is-background .btn-prev),
:deep(.news-pagination .el-pagination.is-background .btn-next),
:deep(.el-pagination.is-background .el-pager li) {
  background-color: #fff !important;
}

</style>